import { useState, useEffect } from 'react';
import { api } from '@/lib/api';

const DOT = { green: 'bg-forest', yellow: 'bg-gold', red: 'bg-red-500' };
const LABEL = { green: 'Strong capacity', yellow: 'Approaching capacity', red: 'Demand exceeds supply' };

export default function AdminCapacity() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get('/admin/capacity').then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-capacity">
      <p className="font-manrope text-dark/60 mb-6">Weekly supplier capacity by category vs. current demand. Red means it's time to recruit another supplier.</p>
      {rows.length === 0 ? (
        <div className="bg-white rounded-2xl border border-forest/10 p-12 text-center font-manrope text-dark/50">No availability data yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-5">
          {rows.map((c) => (
            <div key={c.category} className="bg-white rounded-2xl border border-forest/10 p-6" data-testid={`capacity-${c.category.replace(/[^a-z]/gi, '-')}`}>
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-playfair text-xl font-bold text-dark">{c.category}</h3>
                <span className="flex items-center gap-2 font-manrope text-sm font-semibold"><span className={`w-3 h-3 rounded-full ${DOT[c.status]}`} />{LABEL[c.status]}</span>
              </div>
              <div className="space-y-1 mb-3">
                {c.farms.map((f, i) => <p key={i} className="flex justify-between font-manrope text-sm text-dark/70"><span>{f.farm}</span><span>{f.quantity}</span></p>)}
              </div>
              <div className="border-t border-forest/10 pt-3 font-manrope text-sm">
                <p className="flex justify-between font-semibold text-dark"><span>Total capacity</span><span>{c.total_capacity}</span></p>
                <p className="flex justify-between text-dark/70"><span>Customer demand</span><span>{c.demand}</span></p>
                <p className={`flex justify-between font-semibold ${c.remaining <= 0 ? 'text-red-600' : 'text-forest'}`}><span>Remaining</span><span>{c.remaining}</span></p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
